<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import CustomInterval from './components/customInterval'
import Layout from '@/router/layouts/main'
import { Helper } from '@/mixin/helper'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Custom Interval',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    CustomInterval,
  },
  mixins: [Helper],
  data() {
    return {
      sensors: [],
      pinCodes: [],
      pinCommands: [],
      deviceCommands: [],
      deviceTypes: {
        deviceType: [],
      },
    }
  },
  computed: {
    title() {
      return this.$t('qcdevice.customInterval.title')
    },
  },
  methods: {
    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button @click="$router.back()" variant="outline-primary" class="mx-2">
          <i class="mc-fa icon-outline_arrow-left"></i> {{ $t('global.back') }}
        </b-button>
      </div>
    </div>
    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">{{ title }}</span>
            </template>
            <CustomInterval />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
